<p>
  При обяви с фиксирана цена, продавачите могат да активират опцията <strong>„Приемам ценови предложения“</strong>.
  Ако тази възможност е активна, ще виждате бутон <strong>„Предложи цена“</strong> на страницата на обявата, под
  основната цена.
</p>
<h6 class="mt-3">Как да изпратите предложение?</h6>
<ol>
  <li>Отворете <strong>страницата на избраната обява</strong>.</li>
  <li>Натиснете бутона <strong>„Предложи цена“</strong>.</li>
  <li>Ще се отвори прозорец, в който да въведете:
    <ul>
      <li><strong>Предложена сума</strong> – въведете цената, на която желаете да закупите артикула.
      </li>
      <li><strong>Съобщение до продавача</strong> (по избор) – кратък текст с уточнение или коментар към предложението.
      </li>
    </ul>
  </li>
  <li>Натиснете <strong>„Изпрати“</strong>, за да изпратите предложението си.</li>
</ol>
<h6 class="mt-3">Какво се случва след изпращането?</h6>
<p class="mb-1">
  Продавачът ще получи известие и може да:
</p>
<ul>
  <li><strong>Приеме</strong> предложението – сделката се счита за сключена;</li>
  <li><strong>Откаже</strong> предложението – обявата остава активна;</li>
  <li><strong>Изпрати контрапредложение</strong> – ще може да го приемете или откажете.</li>
</ul>
<p class="mb-1">
  При приемане на предложението, платформата автоматично ще уведоми продавача и ще създаде чат между вас. В него може
  да:
</p>
<ul>
  <li>Уточните детайли по <strong>доставката</strong> и <strong>плащането</strong>;</li>
  <li>Предоставите адрес за доставка или допълнителна информация;</li>
  <li>Получите потвърждение и проследите хода на изпращането.</li>
</ul>
<h6 class="mt-3">Валидност на предложението</h6>
<p>
  Изпратените предложения са <strong>валидни 72 часа</strong>. Ако в този период няма реакция от страна на продавача, те
  се <strong>анулират автоматично</strong>.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Изпращайте реалистични предложения в разумен диапазон. Това увеличава шанса предложението ви
  да бъде прието и да сключите успешна сделка.
</div>
